import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link, useHistory } from 'react-router-dom';
import { Row, Col } from 'antd';
import { stringify } from 'qs';
import TruncateMarkup from 'react-truncate-markup';

import SheetTitle from '../../../components/SheetTitle';
import { slugify, releaseTypeToAlt } from '../../../helpers/view';

import c from './ReleaseBlock.less';

function ReleaseCard({ release, tracking, className }) {
  const history = useHistory();
  const releaseLink = `/release/${slugify(release.name, release.id)}`;
  const artistLink = `/artist/${slugify(release.artist.name, release.artist.id)}`;
  const handleLinkClick = (e) => {
    e.preventDefault();
    const url = new URL(e.currentTarget.href);

    history.push(url.pathname, tracking);
  };

  return (
    <div className={cx(className, c.releaseCard)}>
      <div className={c.cover}>
        <a href={releaseLink} onClick={handleLinkClick}>
          <img
            src={`${release.coverUrl}/230.jpg`}
            alt={`${release.name} mp3 ${releaseTypeToAlt(release.type)} by ${release.artist.name}`}
          />
        </a>
      </div>
      <div className={c.info}>
        <h4 className={c.releaseName}>
          <TruncateMarkup lines={2}>
            <a href={releaseLink} onClick={handleLinkClick}>{release.name}</a>
          </TruncateMarkup>
        </h4>
        <TruncateMarkup lines={2}>
          {
            release.artist.id === 0 ? (
              <span className={c.artistName}>{release.artist.name}</span>
            ) : (
              <a href={artistLink} className={c.artistName} onClick={handleLinkClick}>{release.artist.name}</a>
            )
          }
        </TruncateMarkup>
      </div>
    </div>
  );
}

ReleaseCard.propTypes = {
  release: PropTypes.object.isRequired,
  tracking: PropTypes.object,
};

ReleaseCard.defaultProps = {
  tracking: null,
};

function ReleaseBlock({
  items, q, standalone, total,
}) {
  const columns = {
    lg: standalone ? 6 : 12,
    md: standalone ? 8 : 12,
    xs: standalone ? 24 : 24,
  };

  return (
    <div>
      <SheetTitle
        title="Releases"
        rightBlock={
          !standalone && total > 6 ? (
            <Link to={`/search/releases?${stringify({ q })}`}>Show more</Link>
          ) : null
        }
      />
      <Row className={c.releaseList}>
        {
          items.map((item) => (
            <Col {...columns} key={item.id}>
              <ReleaseCard release={item} />
            </Col>
          ))
        }
      </Row>
    </div>
  );
}

ReleaseBlock.propTypes = {
  items: PropTypes.array,
  total: PropTypes.number,
  q: PropTypes.string.isRequired,
  standalone: PropTypes.bool,
};

ReleaseBlock.defaultProps = {
  items: [],
  total: 0,
  standalone: false,
};

export default ReleaseBlock;

export {
  ReleaseCard,
  ReleaseBlock,
};
